import requestor from "requestor";
import basePath from "base_path";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import ActionTypes from "../constants/action_types";

/* eslint-disable max-params */
export default createReduxPromiseAction(
  ActionTypes.CLAUSEPART_COMMENT_UPDATE,
  (
    organisationId,
    projectId,
    documentId,
    clausepartCommentId,
    changes,
    lastEdited,
  ) =>
    requestor
      .post(
        `${basePath}/organisation/${organisationId}/project/${projectId}` +
          `/document/${documentId}/clausepart_comment/${clausepartCommentId}`,
        {
          changes,
          last_edited: lastEdited,
        },
        {withCredentials: true},
      )
      .then(response => response.data),
);
